import React from "react";

import { QRCodeCanvas } from "qrcode.react";
import { Button } from "reactstrap";
import { LuDownload } from "react-icons/lu";

import { baseUrl, DOWNLOAD_QR_CODE_LABEL } from "../../utils/constants";
import { toastContainer } from "../../utils/toast";

const EnterpriseQrCode = ({ orgId }) => {
  if (!orgId) return null;

  const qrUrl = `${baseUrl().replace(
    /\/$/,
    ""
  )}/employee-register?orgId=${orgId}`;

  const downloadQRCode = () => {
    const canvas = document.querySelector("#enterprise-qrcode-canvas");
    if (!canvas) throw new Error("<canvas> not found in the DOM");
    toastContainer("QR code downloaded.", "success");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "Enterprise QR code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <div className="bwai-as-qr">
      <div className="bwai-as-qr-box">
        <QRCodeCanvas
          id="enterprise-qrcode-canvas"
          level="H"
          size={80}
          value={qrUrl}
        />
      </div>
      <Button className="bwai-btn-secondary bwai-as-qr-btn" onClick={downloadQRCode}>
        <LuDownload size={16} />
        <span className="bwai-as-btn-label">{DOWNLOAD_QR_CODE_LABEL}</span>
      </Button>
    </div>
  );
};

export default EnterpriseQrCode;
